import * as types from './mutation-types';
import { defaultState } from './state';

const resetState_ = state => {
	Object.assign(state, defaultState);
};
export default {
	resetState_,
	[types.DEFAULT_ASSIGN]: (state, payload) => {
		state[payload.key] = payload.value;
	}
};
